import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { InformationalScreen, Stack } from '@adc/parallax-component-library';
import { ApiLoginWarning, ApiStatus, ErrorCode } from 'Constants';
import { useApiError, useAuth, useResendVerificationEmail } from 'Hooks';
import { Footer, MainContainer, TopHeaderBackArrow } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { signIn } from 'Services/auth';
import CheckYourEmailComponents from './components';
const mapStateToProps = ({ auth: { account_id }, env: { deviceId, installationId, osType, osVersion, app, appVersion, appHash }, }) => {
    return { account_id, deviceId, installationId, osType, osVersion, app, appVersion, appHash };
};
const connector = connect(mapStateToProps);
const CheckYourEmail = ({ data: { password, email }, deviceId, installationId, osType, osVersion, app, appVersion, appHash, account_id, }) => {
    const { showApiErrorModal, showNetworkErrorModal } = useApiError();
    const { showCountryRegionError } = useAuth();
    useEffect(() => {
        if (!password || !email) {
            mediator.publish('router:navigate', '/login');
        }
    }, [email, password]);
    const handleGoBack = () => {
        mediator.publish('router:back');
    };
    const handleContinueButtonClick = async () => {
        try {
            const authSession = await signIn({
                email,
                password: password.trim(),
                osType,
                osVersion,
                app,
                appVersion,
                deviceId,
                installationId,
                appHash,
            });
            if (authSession.authentication_steps?.includes(ApiLoginWarning.EMAIL_VERIFICATION)) {
                store.dispatch({
                    type: SHOW_MODAL,
                    modalProps: {
                        header: i18n.t('CheckYourEmailRegistration.modals.verifyEmailDialog.title'),
                        details: i18n.t('CheckYourEmailRegistration.modals.verifyEmailDialog.body'),
                    },
                });
                return;
            }
            notifyApp('adc-webview:signin', authSession);
        }
        catch (err) {
            showApiErrorModal();
        }
    };
    const handleApiRequestError = useCallback((error) => {
        switch (error.status) {
            case ApiStatus.BAD_REQUEST: {
                const code = error.response?.data.code;
                if (code === ApiStatus.UNSUPPORTED_COUNTRY || code === ApiStatus.WRONG_REGION) {
                    showCountryRegionError();
                    return;
                }
                break;
            }
            default:
                error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
        }
    }, [showApiErrorModal, showCountryRegionError, showNetworkErrorModal]);
    const { handleResendEmailButtonClick } = useResendVerificationEmail({
        account_id,
        osType,
        osVersion,
        app,
        appVersion,
        handleApiRequestError,
    });
    return (React.createElement(MainContainer, null,
        React.createElement(InformationalScreen, { topNavigationProps: {
                title: i18n.t('CheckYourEmailRegistration.title'),
                animatedTitle: true,
                buttonStart: {
                    element: React.createElement(TopHeaderBackArrow, { testID: "Auth.action-go-back" }),
                    onPress: handleGoBack,
                },
            }, testID: "CheckYourEmail" },
            React.createElement(InformationalScreen.Page, null,
                React.createElement(InformationalScreen.Content, null,
                    React.createElement(Stack, { marginTop: -8 },
                        React.createElement(CheckYourEmailComponents.Content, { email: email, onButtonPress: handleResendEmailButtonClick }))),
                React.createElement(InformationalScreen.Footer, null,
                    React.createElement(Footer, { buttonLabel: i18n.t('Global.microcopy.common.continue'), onButtonPress: handleContinueButtonClick, buttonTestID: "CheckYourEmailRegistration.continueButton" }))))));
};
export default connector(CheckYourEmail);
